import React from 'react'

function Contact(props) {
    return (
        <div className="container-fluid py-3 d-flex justify-content-center align-item-center" style={{ backgroundColor: props.BGColor }} data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
            <div className="container-sm px-3" style={{ minHeight: "40vh" }} data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                <form style={{ color: props.color }} data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200" action="https://docs.google.com/forms/d/e/1FAIpQLScT114hmL86s6Z9BP8Wji8gx14V53rXxdNkpFjKwQ0H0Si6nw/formResponse" method="post">
                    <div className="row" >
                        <div className="col-md-6 mb-3" data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <label htmlFor="validationDefault01" className='mb-2'>First name</label>
                            <input type="text" name='entry.2005620554' className="form-control" id="validationDefault01" placeholder="First name" required />
                        </div>
                        <div className="col-md-6 mb-3" data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <label htmlFor="validationDefault02" className='mb-2'>Last name</label>
                            <input type="text" name='entry.1487303629' className="form-control" id="validationDefault02" placeholder="Last name" required />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 mb-3" data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <label htmlFor="validationDefault05" className='mb-2'>Contact Number</label>
                            <input type="number" name='entry.408090922' className="form-control" id="validationDefault05" placeholder="+91 00000 00000" required />
                        </div>
                        <div className="col-md-3 mb-3" data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <label htmlFor="validationDefault03" className='mb-2'>Email</label>
                            <input type="email" name='entry.1045781291' className="form-control" id="validationDefault03" placeholder="Email" required />
                        </div>

                        <div className="col-md-3 mb-3" data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <label htmlFor="validationDefault03" className='mb-2'>City</label>
                            <input type="text" name='entry.1166974658' className="form-control" id="validationDefault03" placeholder="City" required />
                        </div>
                        <div className="col-md-3 mb-3" data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <label htmlFor="validationDefault04" className='mb-2'>State</label>
                            <select id="inputState" name="entry.839337160" className="form-control">
                                <option >State...</option>
                                <option value="Andhra Pradesh">Andhra Pradesh</option>
                                <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                                <option value="Assam">Assam</option>
                                <option value="Bihar">Bihar</option>
                                <option value="Chhattisgarh">Chhattisgarh</option>
                                <option value="Goa">Goa</option>
                                <option value="Gujarat">Gujarat</option>
                                <option value="Haryana">Haryana</option>
                                <option value="Himachal Pradesh">Himachal Pradesh</option>
                                <option value="Jharkhand">Jharkhand</option>
                                <option value="Karnataka">Karnataka</option>
                                <option value="Kerala">Kerala</option>
                                <option value="Madhya Pradesh">Madhya Pradesh</option>
                                <option value="Maharashtra">Maharashtra</option>
                                <option value="Manipur">Manipur</option>
                                <option value="Meghalaya">Meghalaya</option>
                                <option value="Mizoram">Mizoram</option>
                                <option value="Nagaland">Nagaland</option>
                                <option value="Odisha">Odisha</option>
                                <option value="Punjab">Punjab</option>
                                <option value="Rajasthan">Rajasthan</option>
                                <option value="Sikkim">Sikkim</option>
                                <option value="Tamil Nadu">Tamil Nadu</option>
                                <option value="Telangana">Telangana</option>
                                <option value="Tripura">Tripura</option>
                                <option value="Uttar Pradesh">Uttar Pradesh</option>
                                <option value="Uttarakhand">Uttarakhand</option>
                                <option value="West Bengal">West Bengal</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3" data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <label htmlFor="validationDefault05" className='mb-2'>Zip</label>
                            <input type="text" name='entry.2125041647' className="form-control" id="validationDefault05" placeholder="Zip" required />
                        </div>
                    </div>
                    <button className="btn" style={{ backgroundColor: props.BGColor === "#DEF2F1" ? "#17252A" : "#DEF2F1", color: !props.color === "#2B7A78" ? "#2B7A78" : "#3AAFA9", border: "1px solid props.color" }} data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200" type="submit">Submit</button>
                </form>
            </div>
        </div>
    )
}

export default Contact
